import React, { Component,Suspense } from 'react';
import renderHTML from 'react-render-html';
import Footer from './Footer';
import { backgroundImage, get_json } from './common';
import ScrollToTop from './scroll'
import { connect } from 'react-redux'
import Loader from './Loader'
import { useImage } from 'react-image'
function BgComponent(props) {
	const { src } = useImage({
		srcList: require('./images/newsletter.jpg')
	})
	return (
    <div className="headerImage" style={{ backgroundImage: 'url(' + src + ')', backgroundSize: 'cover', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat', height: 250, position: 'relative' }}>
    <div className="center_text">
      <h3 className="wthree_text_info">About Us</h3>
    </div>
  </div>
	)
}
class About extends Component {
  constructor(props) {
    super(props);
    this.state = { data: [] };
  }
  async componentDidMount() {
    window.scrollTo(0, 0)
    // await get_json(this)
    if (this.props.alldata === null) {
      await get_json(this)
      this.props.setresponseJson(this.state.data)
    } else {
      await this.setState({ data: this.props.alldata })
    }
    var data_storage = await localStorage.getItem('dataSource');
    var dataSource = JSON.parse(data_storage)
    this.setState({ 'data': dataSource['pages']['About Us'].page_description });
  }
  render() {
    return (

      <div className="main_contact">
        { this.props.alldata === null ? <Loader></Loader>
          :
          <div>

            <div class="aboutdiv">        
                <div class="center_text">
                    <h3>About Us</h3>
                </div>
            </div>
            {renderHTML(`${this.state.data}`)}
            <Footer />
          </div>
        }
      </div>

    );
  }
}
const mapStateToProps = (state) => {
  return {
    alldata: state.responseJson,

  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    setresponseJson: (data) => dispatch({ type: "ALL_RESPONSE", payload: data }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(About);
// export default Home;
// export default About;
